import React, {
  useState,
  useCallback
} from 'react';

import styles from './AutoPageTurn.module.less';
import Header from '../Header';
import useLog from '../../hooks/useLog';

export default ({ size, title, operate, to, source, children }) => {
  const [report] = useLog();

  if (size < 4) return null;

  const [startIndex, setStartIndex] = useState(0);

  const prev = useCallback(() => {
    setStartIndex(startIndex => {
      if (startIndex - 3 < 0) {
        return 0;
      }
      return startIndex - 3;
    });
    report('C', 'Game_Group_ChangePage', {
      handle: 'left',
      source,
    });
  }, [size, report, source]);

  const next = useCallback(() => {
    setStartIndex(startIndex => {
      if (startIndex + 3 > size - 3) {
        return size - 3;
      }
      return startIndex + 3;
    });
    report('C', 'Game_Group_ChangePage', {
      handle: 'right',
      source,
    });
  }, [size, report, source]);

  let distance = startIndex * 262;
  if (startIndex >= size - 3) {
    distance -= 26;
  }

  return (
    <div className={styles.AutoPageTurn}>
      <Header
        title={title}
        operate={operate === '2' ? '2' : '0'}
        to={to}
        source={source}
      />
      <section>
        <div><div style={{transform: `translate(-${distance}px, 0)`}}>{children}</div></div>
        {startIndex > 0 && <b className={styles.prev} onClick={prev}></b>}
        {startIndex < size - 3 && <b className={styles.next} onClick={next}></b>}
      </section>
    </div>
  );
};
